import React from "react";
import { Link } from "react-router-dom";
import "./FraudAlertPage.css";

const fraudAlertTitle = "Recruitment Fraud Alert";

const fraudSignals = [
  "BlackRoth never requests for fees for any purpose during or after the hiring process. BlackRoth will never request money for the opportunity to apply or work.",
  "The hiring process involves at least one interview (virtual or in-person). BlackRoth will not request for an interview on any instant messaging applications.",
  "The BlackRoth Recruitment team corresponds from email addresses with the domain \"@blackroth.in\". However, there is also a possibility of scammers to display the sent email domain address as \"@blackroth.in\" fraudulently. Nevertheless, receiving emails will be possible only with the legitimate \"@blackroth.in\" domain. In case any generic email ID ending with Gmail/Yahoo domain is copied while receiving a job offer or interview call, please be alert on the likelihood of a scammer.",
  "The BlackRoth Recruitment team does not request or require personal documents like bank account details, tax forms or credit card information as part of the recruitment process.",
];

const safetySteps = [
  "Please stay alert and recognize it as a scam.",
  "Visit the official BlackRoth website to verify the source and authenticity.",
];

const FraudAlertPage = () => {
  return (
    <div className="fraud-alert-page">
      <section className="fraud-alert-hero">
        <div className="fraud-alert-hero-inner">
          <p className="fraud-alert-eyebrow">Careers Safety Notice</p>
          <h1 aria-label={fraudAlertTitle}>
            <span className="fraud-alert-title-letters" aria-hidden="true">
              {fraudAlertTitle.split("").map((character, index, characters) => (
                <span
                  key={`${character}-${index}`}
                  className="fraud-alert-title-letter"
                  style={{ "--letter-delay": `${index * 0.05}s` }}
                >
                  {character === " " ? "\u00A0" : character}
                </span>
              ))}
            </span>
          </h1>
          <p className="fraud-alert-hero-copy">
            We would like to bring to your notice that BlackRoth follows a
            merit-based employee recruitment practice with extensive screening
            steps. BlackRoth does not charge/accept any amount or security
            deposit from job seekers during the recruitment process.
          </p>

          <div className="fraud-alert-actions">
            <Link to="/careers" className="fraud-alert-primary-link">
              Explore Careers
            </Link>
            <Link to="/" className="fraud-alert-secondary-link">
              Back to Home
            </Link>
          </div>
        </div>
      </section>

      <div className="fraud-alert-content-shell">
        <section className="fraud-alert-intro-card">
          <h2>Stay alert to common fraud patterns</h2>
          <p>
            We would like to bring to your notice that BlackRoth follows a merit-based employee recruitment practice with extensive screening steps.
            BlackRoth does not charge/accept any amount or security deposit from job seekers during the recruitment process.
            
            It was observed that there has been an increase in recruitment fraud involving scammers who post fraudulent jobs openings, or who contact job-seekers with fake job offers.
            These individuals sometimes even conduct fraudulent interviews with an attempt to obtain personal information or money from the applicants.
            We have also noticed that certain individuals claiming to be from the BlackRoth Recruitment function are contacting prospective candidates pretending to represent BlackRoth with job offers.
            In case you or any candidate receives any unsolicited or fraudulent communication regarding a job offer or an interview call against payment of money, please stay alert and recognize it as a scam.
            On receipt of an interview call, to prevent falling victim to the same, the candidate may take some measures such as visiting the official BlackRoth website to verify the source and authenticity.
          </p>
        </section>

        <section className="fraud-alert-checklist">
          <div className="fraud-alert-section-header">
            <h2>Disclaimer: How to identify recruitment fraud</h2>
          </div>

          <ul className="fraud-alert-points">
            {fraudSignals.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="fraud-alert-response-grid">
          <article className="fraud-alert-panel">
            <h3>Validation</h3>
            <p>
              For BlackRoth - If you are in doubt or unsure about the source of
              job offer, please click{" "} 
              <Link
                to="/validate-and-accept-offer"
                className="fraud-alert-inline-link"
              >
                here
              </Link>{" "}
              to validate.
            </p>
          </article>

          <article className="fraud-alert-panel">
            <h3>Report Immediately</h3>
            <p>
              If you believe you have been a victim of a recruitment fraud, you
              are requested to approach the law enforcement agencies
              immediately.
            </p>
          </article>
        </section>

        <section className="fraud-alert-guidance">
          <h2>Additional Guidance</h2>
          <ul className="fraud-alert-safety-steps">
            {safetySteps.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default FraudAlertPage;
